import template from './flight-segment.html';

const DIRECTIVE_NAME = FlightSegment.DIRECTIVE_NAME = 'ktFlightSegment';
export default function FlightSegment() {
    return {
        restrict: 'A',
        template,
        bindToController: true,
        controller: FlightSegmentController,
        controllerAs: '$ctrl',
        scope: {
            segment: `=${DIRECTIVE_NAME}`,
            recommendation: `=${DIRECTIVE_NAME}Recommendation`,
            selectedFlights: `=${DIRECTIVE_NAME}SelectedFlights`,
            searchParameters: `=${DIRECTIVE_NAME}SearchParameters`,
        },
        link: ($scope, $elem, $attrs, $ctrl) => $ctrl.$onInit(),
    };
}

export function FlightSegmentController(
    flightRecommendationService,
    flightSegmentService,
) {
    'ngInject';

    const vm = this;

    Object.assign(vm, {
        $onInit,
        toggleAlternatives,
        toggleDetails,
        initSelectedGroup,
        isDepartureHighlighted: false,
        isArrivalHighlighted: false,
    });

    function $onInit() {
        initSelectedGroup();
        vm.isAlternativesAvailable = vm.segment.FlightGroups.length > 1;
    }

    function initSelectedGroup() {
        vm.group = flightSegmentService.getSelectedGroup(vm.selectedFlights, vm.segment);
        initHighlightAirports();
        vm.isAlternativesVisible = false;
    }

    function initHighlightAirports() {
        if (!flightRecommendationService.isRoundTrip(vm.recommendation)) {
            return;
        }

        if (flightSegmentService.isOutwardSegment(vm.recommendation, vm.segment)) {
            vm.isDepartureHighlighted = !flightRecommendationService.doesOutwardDepartEqualInwardArrival(vm.selectedFlights, vm.recommendation);
            vm.isArrivalHighlighted = !flightRecommendationService.doesInwardDepartEqualOutwardArrival(vm.selectedFlights, vm.recommendation);
        } else if (flightSegmentService.isReturnSegment(vm.recommendation, vm.segment)) {
            vm.isDepartureHighlighted = !flightRecommendationService.doesInwardDepartEqualOutwardArrival(vm.selectedFlights, vm.recommendation);
            vm.isArrivalHighlighted = !flightRecommendationService.doesOutwardDepartEqualInwardArrival(vm.selectedFlights, vm.recommendation);
        }
    }

    function toggleAlternatives() {
        vm.isAlternativesVisible = !vm.isAlternativesVisible;
        vm.isDetailsVisible = false;
    }

    function toggleDetails() {
        vm.isDetailsVisible = !vm.isDetailsVisible;
        vm.isAlternativesVisible = false;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/flights/flight-recommendation/flight-segment/flight-segment-component.js